import { MessageCircle } from 'lucide-react';

const WHATSAPP_NUMBER = '233242160467';

export const WhatsAppButton = () => {
  const text = encodeURIComponent('Hi DutiLyne! I\u2019d like to know more about pricing for my pharmacy.');
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${text}`}
      target="_blank"
      rel="noreferrer"
      className="wl-whatsapp-float"
      aria-label="Chat with DutiLyne on WhatsApp"
      data-testid="whatsapp-float-button"
    >
      <MessageCircle size={24} />
      <span className="wl-whatsapp-float-pulse" aria-hidden="true" />
    </a>
  );
};
